import { ChangeEvent } from 'react';
import clsx from 'clsx';

import CarouselWrapper from '@atom/components/common/photoCarousel/CarouselWrapper';
import TextLimit from '@atom/components/common/TextLimit';
import { TextField } from '@atom/mui';
import {
  MAX_CHAR_LONG_INPUT,
  REVEAL_LONG,
} from '@atom/selectors/formSelectors';
import { FormFieldType } from '@atom/types/form';
import { Media } from '@atom/types/media';

import FileUploadButton from '../FileUploadButton';
import FileUploadTile from '../FileUploadTile';

import classes from '../formInstance.module.css';

interface PassedProps {
  field: FormFieldType;
  media: Media[];
  fieldId: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  removeFile: (mediaId: string, subjectId: string) => void;
  fieldFileUpload: (event: ChangeEvent<HTMLInputElement>) => void;
  renameMedia: (mediaId: string, subjectId: string, name: string) => void;
  value: any;
  isEditable: boolean;
  isUploadDisabled: boolean;
}

type Props = PassedProps;

const LongTextField = ({
  field,
  fieldId,
  onChange,
  value,
  removeFile,
  isEditable,
  media,
  fieldFileUpload,
  isUploadDisabled,
  renameMedia,
}: Props) => {
  const medium = media.filter((med: Media) => med.fieldId === fieldId);

  return (
    <div className={classes.fieldBlock}>
      <div
        className={clsx(
          classes.longTextfieldContainer,
          field.required && classes.required,
        )}
      >
        <TextField
          variant="standard"
          name={field.type}
          label={field.title}
          multiline
          onChange={onChange}
          value={value}
          disabled={!isEditable}
        />
        {field.fileUpload && (
          <FileUploadButton
            onChange={fieldFileUpload}
            isUploadDisabled={!isEditable || isUploadDisabled}
          />
        )}
      </div>
      <div className={classes.longDescriptionContainer}>
        <div className={classes.fieldDescription}>{field.description}</div>
        <TextLimit
          limit={MAX_CHAR_LONG_INPUT}
          reveal={REVEAL_LONG}
          text={value}
        />
      </div>
      <div className={classes.fileTileContainer}>
        {medium.map((mediaItem: Media) => (
          <CarouselWrapper
            media={media}
            selectedMediaId={mediaItem.id}
            removeFile={removeFile}
            subjectId={fieldId}
            renameMedia={renameMedia}
            canUpdateMedia={isEditable}
            canDeleteMedia={isEditable}
          >
            <FileUploadTile key={mediaItem.id} media={mediaItem} />
          </CarouselWrapper>
        ))}
      </div>
    </div>
  );
};

export default LongTextField;
